import { Filters } from '@/types/globalFilter';
import { GetAllPatientsRequestParams } from '@/types/patient';

import { PatientActiveStatusEnum, PatientMenuOptions } from './constants';
import { LabelAndValue } from '@/types/custom';


export type PatientOptionsFilter = {
  value: PatientMenuOptions;
  label: string;
};

export type ReportOptionsFilter = {
  value: PatientMenuOptions;
  label: string;
};

export type StatusFilter = {
  value: PatientActiveStatusEnum;
  label: string;
};

export interface PatientFilters {
  patientOptions: PatientOptionsFilter;
  reportOptions: ReportOptionsFilter;
  status: StatusFilter;
  search: string | undefined;
  deviceSchedule: LabelAndValue | undefined;
  clinics: LabelAndValue[] | undefined;
  practitioners: LabelAndValue[] | undefined;
  devices: LabelAndValue[] | undefined;
  vendors: LabelAndValue[] | undefined;
}

export const getFilters = (
  filters: PatientFilters,
  globalFilter: Filters | null
): Partial<GetAllPatientsRequestParams> => {
  return {
    deviceSchedule: filters?.deviceSchedule?.value,
    isDownloaded:
      filters.reportOptions.value === PatientMenuOptions.NOT_DOWNLOAD ? true : undefined,
    isNew: filters.patientOptions.value === PatientMenuOptions.NEW,
    isRecentSigned: filters.reportOptions.value === PatientMenuOptions.RECENT ? true : undefined,
    status: filters.status.value,
    search: filters.search,
    clinicIds: globalFilter?.clinics?.map((clinic) => clinic.value) ?? undefined,
    practitionersIds:
      globalFilter?.practitioners?.map((practitioner) => practitioner.value) ?? undefined,
    deviceTypes: globalFilter?.deviceTypes?.map((deviceType) => deviceType.value) ?? undefined,
    vendors: undefined,
    patientStatuses: globalFilter?.patientStatuses?.map((status) => status.value) ?? undefined
  };
};
